import { render, staticRenderFns } from "./PviTableMenu.vue?vue&type=template&id=12515aba&scoped=true&"
import script from "./PviTableMenu.vue?vue&type=script&lang=js&"
export * from "./PviTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12515aba",
  null
  
)

export default component.exports